import React from 'react'
import QuoteContent from './Components/quote';
import {Helmet} from 'react-helmet';
import QuoteHead from '../../Components/Head/Quotehead';



function Quote() {
  return (
    <>
    <Helmet>
      
    </Helmet>
      <div>
        <QuoteHead />
        <QuoteContent />
      </div>
    </>
  )
}  

export default Quote